import styled from "styled-components";

export const ScheduleItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 5px;

  .schedule-name {
    margin: 0;
    margin-bottom: 10px;
  }

  .item {
    display: flex;
    align-items: center;

    p,
    a {
      font-size: 0.875rem;
      margin: 0;
    }

    a {
      margin-left: 5px;
    }
  }
`;
